Vue.component('sponsorship-invitation', require('./SponsorshipInvitation.vue').default);
Vue.component('sponsorship-share', require('./SponsorshipShare.vue').default);
